import request from "@/utils/request";
import {USER_TYPE} from "@/constant";

const api = {
  page: `/admin/contacts/emp/page`,
  list: `/admin/contacts/emp/list`,
  add: `/admin/contacts/emp/add`,
  edit: `/admin/contacts/emp/edit`,
  delete: `/admin/contacts/emp/delete`,
  selector: `/admin/contacts/emp/selector`,
  userTree: "/admin/contacts/emp/tree",
  updateAdminStatus: "/admin/contacts/emp/updateAdminStatus",
  updateIsAdminGroup: "/admin/contacts/emp/updateIsAdminGroup",
  updateLoginUserInfo: "/admin/contacts/updateUser",

  //前台接口
  contact: "/contacts/user/emp/contact",
  searchContact: `/contacts/emp/searchContact`,
  totalNumber: `/contacts/emp/totalNumber`,
  getLoginUserDetailInfo: `/contacts/emp/loginUserDetailInfo`,
  // updateLoginUserInfo: `/contacts/emp/updateLoginUserInfo`,
  updatePassword: "/updatePassword",
};

export function pageEmp(parameter) {
  return request({
    url: api.page,
    method: "get",
    params: parameter,
  });
}

export function listEmp(parameter) {
  return request({
    url: api.list,
    method: "get",
    params: parameter,
  });
}

export function addEmp(parameter) {
  return request({
    url: api.add,
    method: "post",
    data: parameter,
  });
}

export function editEmp(parameter) {
  return request({
    url: api.edit,
    method: "post",
    data: parameter,
  });
}

export function deleteEmp(parameter) {
  return request({
    url: api.delete,
    method: "post",
    data: parameter,
  });
}

export function pageStu(parameter) {
  return request({
    url: api.page,
    method: "get",
    params: parameter,
  });
}

export function addStu(parameter) {
  return request({
    url: api.add,
    method: "post",
    data: parameter,
  });
}

export function editStu(parameter) {
  return request({
    url: api.edit,
    method: "post",
    data: parameter,
  });
}

export function deleteStu(parameter) {
  return request({
    url: api.delete,
    method: "post",
    data: parameter,
  });
}

/**
 * 教职工选择器
 * @param {} parameter
 * @returns
 */
export function selectorEmp(parameter) {
  return request({
    url: api.selector,
    method: "get",
    params: parameter,
  });
}

/**
 * 获取通讯录
 * @param {} parameter
 * @returns
 */
export function contact(parameter) {
  return request({
    url: api.contact,
    method: "get",
    params: parameter,
  });
}

/**
 * 通讯录搜索教职工
 * @param {} parameter
 * @returns
 */
export function searchEmpContact(parameter) {
  return request({
    url: api.searchContact,
    method: "get",
    params: parameter,
  });
}


export function getLoginUserDetailInfo() {
  return request({
    url: api.getLoginUserDetailInfo,
    method: "get",
  });
}

export function updateLoginUserInfo(parameter) {
  return request({
    url: api.updateLoginUserInfo,
    method: "post",
    data: parameter,
  });
}

export function updatePassword(parameter) {
  return request({
    url: api.updatePassword,
    method: "post",
    data: parameter,
  });
}

export function updateAdminStatus(parameter) {
  return request({
    url: api.updateAdminStatus,
    method: "post",
    data: parameter,
  });
}

export function updateIsAdminGroup(parameter) {
  return request({
    url: api.updateIsAdminGroup,
    method: "post",
    data: parameter,
  });
}
